import { Button, Checkbox, Modal } from "antd";

export default function DeleteAccessGroup({ props }) {
  return (
    <Modal
      visible={props.deleteVisible}
      title="Delete this access group?"
      onCancel={props.toggleDeletePopup}
      footer={[
        <Button key="Back" onClick={props.toggleDeletePopup}>
          Return
        </Button>,
        <Button
          type="danger"
          key="Delete"
          className={"btn btn-success"}
          loading={props.loading}
          onClick={props.hardDelete}
        >
          Permanent Delete
        </Button>,
      ]}
    >
      <div className="p-2">
        {props.editingData?.name}
      </div>

      <div className="p-2-small-text">
        <ul>
          <li>
            <p>
              accessgroup contain {props.editingData?.course?.length} course
            </p>
          </li>
        </ul>
      </div>

      <div className="p-2">
        <strong>Check all</strong> the items below to confirm accessgroup deletion, Deleting a accessgroup is permanent and <strong>cannot</strong> be undone
      </div>

      <div className="frame-detail">
        <div>
          <Checkbox
            onChange={(value) => {
              props.setCheckBox1(value.target.checked);
            }}
            checked={props.checkBox1}
          >
            Any future access of the data will be impossible
          </Checkbox>
        </div>

        <div>
          <Checkbox
            onChange={(value) => {
              props.setCheckBox2(value.target.checked);
            }}
            checked={props.checkBox2}
          >
            Any subscription record related to this accessgroup will also be delete permanantly
          </Checkbox>
        </div>
      </div>
    </Modal>
  );
}